<template>
  <ion-app>
    <Loading v-if="loadingMessage" />
    <Menu></Menu>
    <ion-router-outlet id="main-content" />
  </ion-app>
</template>

<script>
import { mapState } from 'pinia'
import { authStore } from './store/auth'
import { IonApp, IonRouterOutlet } from "@ionic/vue";
import Menu from "./components/Menu.vue";
import Loading from "./components/Loading.vue";

export default {
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
    Menu,
    Loading,
  },
  computed: {
    ...mapState(authStore, ['loadingMessage'])
  },
};
</script>
<style>
</style>